import React from 'react';
import { Button } from 'react-bootstrap';
import { DeleteIcon } from 'components/Icons';
import { useTranslation } from 'react-i18next';

/**
 *  @PROPS
 *  ref: object//Forwarding refs to DOM components .
 *  onChange: function //Callback function to run on change. Accepts parameter event.
 *  uploadType: string//HTML5 input type. Defaults to file.
 *  customClass: object//React type styles to apply to the internal input element.
 *  uploadLabel: string//Label text to display inside input.
 *  UploadIcon: image//image to display inside input.
 *  attachment: array//media files array.
 *  handleFileDelete:function //Callback function to delete media files.Accepts parameter url.
 *  mediaTypes:strings//HTML5 input accept types.
 * disabled: Boolean
 */

const MessageInput = React.forwardRef(
    (
        { uploadType = 'file', customClass, onChange, attachment, handleFileDelete, uploadLabel, UploadIcon, mediaTypes, disabled },
        ref
    ) => {
        const { t } = useTranslation();
        return (
            <>

                <div className={'d-flex align-items-center pt-3'}>
                    <div className={'d-flex'}>
                        <input
                            type={uploadType}
                            className={customClass}
                            onChange={e => onChange(e)}
                            style={{ display: 'none' }}
                            ref={ref}
                            accept={mediaTypes}
                        />
                    </div>

                    <div className={'d-flex'}>
                        <Button
                            type="button"
                            onClick={() => {
                                ref.current.click();
                            }}
                            disabled={disabled}
                            className="main-button btn-transparent"
                            style={{ zIndex: 10 }}
                        >
                            <UploadIcon />
                        </Button>
                    </div>
                </div>

            </>
        );
    }
);

export default MessageInput;

